export enum BasketItemHanding {
    RH = 'RH',
    LH = 'LH'
}